import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './components/HeroSection';
import About from './components/AboutComponents';
import Projects from './pages/Ourproject';
import GetInvolved from './pages/GetInvolved';
import Gallery from "./pages/Gallery";
import Navbar from "./components/Navbar";
import Contactus from "./pages/Contactus";

import usePageTitle from "./components/Usepagetitle"; // Import your custom hook

function App() {
  return (
    <BrowserRouter>
      <TitleManager /> {/* <- Add this to handle title changes */}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/getinvolved" element={<GetInvolved />} />
        <Route path="/contactus" element={<Contactus />} />
      </Routes>
    </BrowserRouter>
  );
}

function TitleManager() {
  usePageTitle();
  return null; // this component just runs the hook
}

export default App;
